import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { IconComponent } from '../../../icon/icon.component';
import { RtPlanButtonVariant } from '../../button.types';
import { BaseButtonDirective } from './../../base-button';

@Component({
  standalone: true,
  selector: 'rt-plan-button, a[rt-plan-button]',
  templateUrl: './plan-button.component.html',
  styleUrls: ['./../../styles/base.less', './plan-button.component.less'],
  // eslint-disable-next-line
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class PlanButtonComponent extends BaseButtonDirective {
  @Input() public variant: RtPlanButtonVariant = 'scale';
}
